import { useContext } from 'react';
import { SourceBlockContext } from './SourceBlockContext';

export const useSourceBlockContext = () => {
    const context = useContext(SourceBlockContext);

    if (!context) {
        throw new Error('useSourceBlockContext must be used within a SourceBlockProvider');
    }

    return context;
};
